module.exports = __webpack_public_path__ + "static/img/info-search-banner @2x.470a075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/info-search-banner @2x.png
// module id = 924
// module chunks = 0